import React from 'react';
import { motion } from 'framer-motion';
import { Leaf, ShieldCheck, CheckCircle2 } from 'lucide-react';
import { Button } from './ui/Button';
export function Hero() {
  const scrollToPricing = () => {
    const target = document.getElementById('pricing');
    if (!target) return;
    const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - 40;
    const startPosition = window.pageYOffset;
    const distance = targetPosition - startPosition;
    const duration = 2000; // slow scroll, 2s
    let startTime: number | null = null;
    const easeInOutQuad = (t: number) => t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    const animation = (currentTime: number) => {
      if (startTime === null) startTime = currentTime;
      const timeElapsed = currentTime - startTime;
      const progress = Math.min(timeElapsed / duration, 1);
      const ease = easeInOutQuad(progress);
      window.scrollTo(0, startPosition + distance * ease);
      if (timeElapsed < duration) requestAnimationFrame(animation);
    };
    requestAnimationFrame(animation);
  };
  return <section className="relative pt-12 pb-20 md:pt-20 md:pb-32 overflow-hidden bg-cream" data-id="element-208">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-209">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-210">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="max-w-2xl" data-id="element-211">
            <span className="inline-block py-1 px-3 rounded-full bg-sage-100 text-sage-800 text-xs font-semibold tracking-widest uppercase mb-6" data-id="element-212">
              El Programa Integral
            </span>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6 text-charcoal" data-id="element-213">
              ¿Sientes que tu cuerpo cambió sus reglas y nadie te dio el nuevo
              manual?
            </h1>

            <p className="text-lg md:text-xl text-charcoal-light mb-8 leading-relaxed" data-id="element-214">
              Recupera tu energía, desinflama tu abdomen y calma tus noches con{' '}
              <strong className="font-semibold text-sage-700" data-id="element-215">
                Vuelve a Sentirte Tú: Menopause Reset
              </strong>
              . El programa integral de 15 módulos diseñado para la mujer
              moderna.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-10" data-id="element-216">
              <Button onClick={scrollToPricing} className="w-full sm:w-auto text-lg" data-id="element-217">
                SÍ, QUIERO MI RESET AHORA
              </Button>
            </div>

            {/* Trust Signals */}
            <div className="flex flex-wrap items-center gap-4 md:gap-6 text-sm text-charcoal-light font-medium" data-id="element-218">
              <div className="flex items-center gap-1.5" data-id="element-219">
                <CheckCircle2 size={18} className="text-sage-600" data-id="element-220" />
                <span data-id="element-221">15 módulos</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-222">
                <Leaf size={18} className="text-sage-600" data-id="element-223" />
                <span data-id="element-224">Método natural</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-225">
                <ShieldCheck size={18} className="text-sage-600" data-id="element-226" />
                <span data-id="element-227">Garantía 30 días</span>
              </div>
            </div>
          </motion.div>

          {/* Image */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} className="relative lg:ml-auto" data-id="element-228">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl" data-id="element-229">
              <img src="https://cdn.magicpatterns.com/uploads/jz3azFHBVCSxNFfC5PdoyH/Mockup_Principal_Pagina.png" alt="Vuelve a Sentirte Tú - Menopause Reset Program con bonos exclusivos" className="w-full h-auto object-contain" data-id="element-230" />
            </div>
            {/* Decorative background blob */}
            <div className="absolute -inset-4 bg-sage-100 rounded-[3rem] -z-10 transform rotate-3 scale-105 opacity-50 blur-xl" data-id="element-231"></div>
          </motion.div>
        </div>
      </div>
    </section>;
}